// extracted by mini-css-extract-plugin
module.exports = {"container":"QrCode_container__2ELlh","qrCodeLoading":"QrCode_qrCodeLoading__hSPST","qrCode":"QrCode_qrCode__3OnC5","qrCodeLoaded":"QrCode_qrCodeLoaded___GqCt"};